const Left = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.35125 7.375L2.14567 7.375L2.99738 8.22824L7.26383 12.5023C7.40919 12.648 7.40909 12.8838 7.2636 13.0293C7.11802 13.1749 6.88198 13.1749 6.7364 13.0293L0.989918 7.28281C0.833724 7.12662 0.833725 6.87338 0.989916 6.71719L6.7364 0.970705C6.88198 0.825124 7.11802 0.825124 7.2636 0.970705C7.40909 1.11619 7.40919 1.35204 7.26383 1.49766L2.99738 5.77176L2.14567 6.625L3.35125 6.625L13.125 6.625C13.3321 6.625 13.5 6.79289 13.5 7C13.5 7.20711 13.3321 7.375 13.125 7.375L3.35125 7.375Z"
      fill="#333333"
      stroke="#1890FF"
    />
  </svg>
)

export default Left
